import React from 'react';
import { createGlobalStyle } from 'styled-components';

const GlobalCursor = createGlobalStyle`
  body {
    cursor: url(${() => `/assets/${process.env.GATSBY_PROPERTY_NAME}/images/alt-cursor.png`}), default;
  }
`;

export const CustomCursor = () => (<GlobalCursor />);

CustomCursor.propTypes = {};
